import { api } from "@/lib/api";
import { toast } from "sonner";

export const fmtBRL = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const fmtNum = (v, d = 2) => (Number(v) || 0).toLocaleString("pt-BR", { maximumFractionDigits: d });
export const fmtDate = (s) => (s ? String(s).slice(0, 10).split("-").reverse().join("/") : "—");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("pt-BR") : "—");

export const STATUS = {
  rascunho: { label: "Em elaboração", color: "#94A3B8" },
  enviada: { label: "Enviada", color: "#3B82F6" },
  em_analise: { label: "Em análise", color: "#F59E0B" },
  devolvida: { label: "Devolvida", color: "#F97316" },
  rejeitada: { label: "Rejeitada", color: "#EF4444" },
  aprovada_fiscal: { label: "Aprovada (fiscal)", color: "#22C55E" },
  aprovada_final: { label: "Aprovada (final)", color: "#009C3B" },
  paga: { label: "Paga", color: "#10B981" },
};

export const ACAO_LABEL = {
  criada: "Medição criada", enviada: "Enviada à fiscalização", reenviada: "Reenviada após correções",
  receber: "Recebida para análise", aprovar_tecnico: "Aprovação técnica (fiscal)", devolver: "Devolvida para correção",
  rejeitar: "Rejeitada", aprovar_final: "Aprovação final", registrar_pagamento: "Pagamento registrado",
  pagamento_estornado: "Pagamento estornado",
};

export function StatusBadge({ status, testid, valorPago }) {
  const s = status === "aprovada_final" && valorPago > 0
    ? { label: "Paga parcialmente", color: "#14B8A6" } : (STATUS[status] || { label: status, color: "#94A3B8" });
  return (
    <span data-testid={testid} className="px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap"
          style={{ background: `${s.color}22`, color: s.color }}>{s.label}</span>
  );
}

export async function fetchBlobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export async function openPdf(path, filename) {
  try {
    const url = await fetchBlobUrl(path);
    const a = document.createElement("a");
    a.href = url; a.target = "_blank"; a.rel = "noopener";
    if (filename) a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    toast.error("Não foi possível gerar o arquivo");
  }
}

export const errMsg = (e, fb = "Erro na operação") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fb;
};
